<template>
  <div>
    <b-modal
      :visible="isLifelineActive"
      id="lifeline"
      centered
      hide-footer
      hide-header
      size="lg"
      @hide="onCloseLifeline"
    >
      <template v-if="isLifelineActive">
        <ProcessingGif :classes="'popup-processing-image'" />
        <template v-if="!isLoading">
          <b-row v-if="showError" class="alert-messages">
            <b-col>
              <b-alert show variant="danger">{{errorMessage}}</b-alert>
            </b-col>
          </b-row>
          <slot :session="session"></slot>
        </template>
      </template>
      <b-link block class="centered-block close-button" variant="secondary" @click="close()">&times;</b-link>
    </b-modal>
    <template v-if="!isLifelineActive">
      <template v-if="session && session.is_popup">
        <b-modal
          id="session-popup"
          centered
          hide-footer
          hide-header
          no-close-on-backdrop
          no-close-on-esc
          size="xl"
          :modal-class="{'confirmation-popup': !session.is_legacy && isConfirmationPopup}"
          :visible="session && session.is_popup"
        >
          <ProcessingGif :classes="'popup-processing-image'" :processing="isPopupLoading" />
          <div :class="{'d-none': isPopupLoading}">
            <slot :session="popupSession"></slot>
          </div>
        </b-modal>
      </template>
      <template>
        <slot :session="session"></slot>
      </template>
    </template>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import {InputType, SessionResult} from '@/constants'
import {getErrorMessage} from '@/utils'
import ProcessingGif from '@/components/ProcessingGif'

export default {
  name: 'SessionContainer',
  components: {ProcessingGif},
  computed: {
    ...mapState(['session', 'isLoading', 'error', 'popupSession', 'isPopupLoading']),
    ...mapGetters(['isLifelineActive']),
    showError: function() {
      return this.error && (this.session.lifeline_status === SessionResult.LifelineError)
    },
    errorMessage: function() {
      return getErrorMessage(this.error)
    }
  },
  methods: {
    close: function() {
      this.$bvModal.hide('lifeline')
    },
    onCloseLifeline: function() {
      this.$store.commit('reset_lifeline')
      this.$store.commit('clear_messages')
      this.$store.commit('reset_idle_timer')

      if (this.session && this.session.can_exit_lifeline && !this.session.show_lifeline_contact) {
        this.$store.commit('busy')
        this.$store.dispatch('close')
          .then(session => {
            console.log('Closed the lifeline')
            this.$router.go(0) // refresh
          })
          .catch(err => {
            console.log(err)

            if (err.response && err.response.status === 422) {
              // unprocessable, but not an error - just refresh
              this.$store.dispatch('get_session')
                .then(session => {
                  this.$router.go(0)
                })
                .catch(err => {
                  this.$store.commit('critical_error', err)
                })
            } else {
              this.$store.commit('critical_error', err)
            }
          })
      }
    },
    isConfirmationPopup: function() {
      return this.session && this.session.step_type === InputType.Confirmation
    }
  }
}
</script>

<style scoped lang="less">
  #session-popup {
    .modal-body {
      padding: 0 0.5rem;

      [class*='col'] {
        padding-left: 2px;
        padding-right: 2px;
      }
    }
  }

  @media only screen and (min-width: 415px) and (max-width: 575px) {
    #session-popup {
      .modal-body {
        padding: 0 1rem;
      }
    }
  }
</style>
